import { Injectable, Injector } from '@angular/core';
import { OidcBaseService } from './oidc.service';

type Constructor<T> = {
  new(...args: any[]): T;
  readonly prototype: T;
}
export enum AuthenticationType {
  SSOJWT = 'SSOJWT',
  COGNITO = 'COGNITO',
  CONNECTWISE = 'CONNECTWISE',
  SBAM = 'SBAM'
}

@Injectable({
  providedIn: 'root'
})
export class OidcFactory {
  static implementations: object = {};

  constructor(private injector: Injector) {
  }

  static register(typeName: AuthenticationType) {
    return <T extends Constructor<OidcBaseService>>(ctor: T) => {
      if (OidcFactory.implementations.hasOwnProperty(typeName)) {
        console.error('This OIDC provider has already been registered. Did you forget to change the argument for @Register()?');
      }
      else {
        OidcFactory.implementations[typeName] = ctor;
      }
      return ctor;
    }
  }

  getOidcService(typeName: AuthenticationType) : OidcBaseService {
    if (!OidcFactory.implementations.hasOwnProperty(typeName)) {
      throw new Error('This OIDC provider does not exist. Did you forget to @Register() it?');
    }
    const component = OidcFactory.implementations[typeName];
    return this.injector.get<any>(component);
  }

  isOidcService(typeName: AuthenticationType) : boolean {
    return OidcFactory.implementations.hasOwnProperty(typeName);
  }
}